/** برچسب فارسی و رنگ فعالیت‌های تاریخچه */
export const HISTORY_EVENT_LABELS = {
  'bank-account-created': { label: 'حساب بانکی ساخته شد', color: 'green' },
  'bank-account-updated': { label: 'حساب بانکی آپدیت شد', color: 'blue' },
  'client-created': { label: 'مشتری ایجاد شد', color: 'green' },
  'contract-created': { label: 'قرارداد ایجاد شد', color: 'green' },
  'contract-updated': { label: 'قرارداد آپدیت شد', color: 'blue' },
  'contract-deleted': { label: 'قرارداد حذف شد', color: 'red' },
  'creditNote-created': { label: 'یادداشت اعتباری ایجاد شد', color: 'green' },
  'creditNote-updated': { label: 'یادداشت اعتباری آپدیت شد', color: 'blue' },
  'creditNote-deleted': { label: 'یادداشت اعتباری حذف شد', color: 'red' },
  'note-added': { label: 'یادداشت اضافه شد', color: 'green' },
  'note-deleted': { label: 'یادداشت حذف شد', color: 'red' },
  'file-added': { label: 'فایل اضافه شد', color: 'cyan' },
  'file-deleted': { label: 'فایل حذف شد', color: 'red' },
  'pipeline-updated': { label: 'مسیر فروش آپدیت شد', color: 'purple' },
  'followup-created': { label: 'پیگیری ایجاد شد', color: 'cyan' },
  'followup-deleted': { label: 'پیگیری حذف شد', color: 'red' },
  'stage-updated': { label: 'مرحله بروزرسانی شد', color: 'blue' },
  'step-updated': { label: 'مرحله بروزرسانی شد', color: 'blue' },
  'deal-updated': { label: 'معامله بروزرسانی شد', color: 'blue' },
  'deal-created': { label: 'معامله ایجاد شد', color: 'green' },
  'deal-deleted': { label: 'معامله حذف شد', color: 'red' },
  'estimate-created': { label: 'پیش فاکتور ایجاد شد', color: 'green' },
  'estimate-updated': { label: 'پیش فاکتور آپدیت شد', color: 'blue' },
  'estimate-deleted': { label: 'پیش فاکتور حذف شد', color: 'red' },
  'event-created': { label: 'رویداد ایجاد شد', color: 'green' },
  'event-updated': { label: 'رویداد آپدیت شد', color: 'blue' },
  'event-deleted': { label: 'رویداد حذف شد', color: 'red' },
  'expenses-created': { label: 'هزینه ایجاد شد', color: 'green' },
  'expenses-updated': { label: 'هزینه آپدیت شد', color: 'blue' },
  'expenses-deleted': { label: 'هزینه حذف شد', color: 'red' },
  'invoice-deleted': { label: 'فاکتور حذف شد', color: 'red' },
  'followUp-created': { label: 'فعالیت پیگیری ایجاد شد', color: 'cyan' },
  'followUp-updated': { label: 'فعالیت پیگیری آپدیت شد', color: 'geekblue' },
  'followUp-deleted': { label: 'فعالیت پیگیری حذف شد', color: 'red' },
  'leave-created': { label: 'مرخصی ایجاد شد', color: 'green' },
  'leave-updated': { label: 'مرخصی آپدیت شد', color: 'blue' },
  'leave-deleted': { label: 'مرخصی حذف شد', color: 'red' },
  'order-created': { label: 'سفارش ایجاد شد', color: 'green' },
  'order-updated': { label: 'سفارش آپدیت شد', color: 'blue' },
  'order-deleted': { label: 'سفارش حذف شد', color: 'red' },
  'payment-updated': { label: 'پرداخت آپدیت شد', color: 'blue' },
  'payment-deleted': { label: 'پرداخت حذف شد', color: 'red' },
  'product-created': { label: 'محصول ایجاد شد', color: 'green' },
  'product-updated': { label: 'محصول آپدیت شد', color: 'blue' },
  'product-deleted': { label: 'محصول حذف شد', color: 'red' },
  'project-created': { label: 'پروژه ایجاد شد', color: 'green' },
  'project-updated': { label: 'پروژه آپدیت شد', color: 'blue' },
  'project-deleted': { label: 'پروژه حذف شد', color: 'red' },
  'timelog-created': { label: 'ثبت زمان ایجاد شد', color: 'green' },
  'timelog-updated': { label: 'ثبت زمان آپدیت شد', color: 'blue' },
  'timelog-deleted': { label: 'ثبت زمان حذف شد', color: 'red' },
  'proposal-created': { label: 'پروپوزال ایجاد شد', color: 'green' },
  'proposal-updated': { label: 'پروپوزال آپدیت شد', color: 'blue' },
  'proposal-deleted': { label: 'پروپوزال حذف شد', color: 'red' },
  'task-created': { label: 'وظیفه ایجاد شد', color: 'green' },
  'task-updated': { label: 'وظیفه آپدیت شد', color: 'blue' },
  'task-deleted': { label: 'وظیفه حذف شد', color: 'red' },
  'ticket-created': { label: 'تیکت ایجاد شد', color: 'green' },
  'ticket-updated': { label: 'تیکت آپدیت شد', color: 'blue' },
  'ticket-deleted': { label: 'تیکت حذف شد', color: 'red' },
  'step-updated': { label: 'تغییر مرحله', color: 'blue' },
  'lead-step-updated': { label: 'تغییر مرحله سرنخ', color: 'blue' },
  created: { label: 'ایجاد', color: 'green' },
  updated: { label: 'به‌روزرسانی', color: 'orange' },
};

export const getHistoryEventMeta = (eventType) => {
  const key = String(eventType || '').trim();
  if (HISTORY_EVENT_LABELS[key]) return HISTORY_EVENT_LABELS[key];
  const lower = key.toLowerCase();
  if (HISTORY_EVENT_LABELS[lower]) return HISTORY_EVENT_LABELS[lower];
  if (lower.includes('created')) return { label: 'ایجاد', color: 'green' };
  if (lower.includes('deleted')) return { label: 'حذف', color: 'red' };
  if (lower.includes('updated')) return { label: 'به‌روزرسانی', color: 'blue' };
  return { label: key || 'فعالیت', color: 'default' };
};
